/*
 * GMAN cart progress bar updater: free shipping at $50, then 10% off at $100.
 * Redraws every .gman-free-shipping-box (snippets/gman-ship-bar.liquid) after each
 * cart change. Thresholds and the discount title match come from the box's data
 * attributes, so edit them in the snippet, not here.
 * EDITABLE TEXT: messages() below. EDITABLE COLORS: ORANGE / GREEN.
 */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

if (!customElements.get('free-shipping-updater')) {
  /* UI text: window.GMAN_T comes from snippets/gman-i18n.liquid (locale keys gman.js.*). The English fallback keeps the store working if that snippet is missing. */
  function T(k, en, vars) {
    var s = window.GMAN_T && window.GMAN_T[k] != null ? window.GMAN_T[k] : en;
    if (vars) Object.keys(vars).forEach(function (v) { s = s.split('{' + v + '}').join(vars[v]); });
    return s;
  }
  var ORANGE = '#ff9a00';
  var GREEN = '#28a745';

  // True when Shopify applied a discount whose title contains the match text
  var tierApplied = function (cart, match) {
    match = (match || '').toLowerCase();
    if (!match) return false;
    var hit = function (title) { return String(title || '').toLowerCase().indexOf(match) !== -1; };
    if ((cart.cart_level_discount_applications || []).some(function (d) { return hit(d.title); })) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        return a.discount_application && hit(a.discount_application.title);
      });
    });
  };

  var messages = function (stage, left) {
    if (stage === 'done') return T('fs_done', 'You unlocked free shipping and 10% off');
    if (stage === 'tier') return left > 0 ? T('fs_tier', 'Free shipping unlocked. Add {amount} more for 10% off', { amount: formatMoney(left) }) : T('fs_unlocked', 'You unlocked free shipping');
    return T('fs_away', "You're only {amount} away from free shipping", { amount: formatMoney(left) });
  };

  class FreeShippingUpdater extends HTMLElement {
    constructor() {
      super();
      this.cartUpdateUnsubscriber = undefined;
    }

    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.updateFreeShipping.bind(this));
      // Also run immediately on load to correct stale Liquid render
      this.updateFreeShipping();
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    async updateFreeShipping() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const total = cart.total_price;
        const preDiscount = cart.original_total_price || cart.items_subtotal_price || total;

        document.querySelectorAll('.gman-free-shipping-box').forEach(box => {
          const ship = parseInt(box.dataset.ship, 10) || 5000;
          const tier = parseInt(box.dataset.tier, 10) || 10000;
          const textElement = box.querySelector('[data-ship-text]') || box.querySelector('p');
          const progressBar = box.querySelector('[data-ship-fill]') || box.querySelector('div > div');

          let stage, left = 0, width;
          if (tierApplied(cart, box.dataset.tierMatch)) {
            stage = 'done'; width = 100;
          } else if (total >= ship) {
            stage = 'tier'; left = Math.max(0, tier - preDiscount); width = (preDiscount / tier) * 100;
          } else {
            stage = 'ship'; left = ship - total; width = (total / ship) * 100;
          }

          if (textElement) {
            textElement.textContent = messages(stage, left);
            textElement.style.fontWeight = stage === 'ship' ? '' : '600';
          }
          if (progressBar) {
            progressBar.style.width = Math.min(100, Math.round(width)) + '%';
            progressBar.style.background = stage === 'ship' ? ORANGE : GREEN;
          }
        });
      } catch (error) {
        console.error('Error updating free shipping progress:', error);
      }
    }
  }

  customElements.define('free-shipping-updater', FreeShippingUpdater);

  // Initialize the updater
  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('free-shipping-updater')) {
      document.body.appendChild(document.createElement('free-shipping-updater'));
    }
  });
}
